import _ from 'lodash';
/* @ngInject */
export default function accountsFactory($http, HPConfig) {
    const accountsPages = [{
        pageName: 'licenses',
        pageDisplayName: 'Licenses',
        isEnabled: true,
        url: 'app/accounts/licenses/licenses.html',
        isPublic: false,
    },
    {
        pageName: 'company',
        pageDisplayName: 'Company',
        isEnabled: false,
        url: 'app/accounts/company/company.html',
        isPublic: false,
    },
    {
        pageName: 'offices',
        pageDisplayName: 'Offices',
        isEnabled: true,
        url: 'app/accounts/offices/offices.html',
        isPublic: false,
    },
    {
        pageName: 'users',
        pageDisplayName: 'Users',
        isEnabled: true,
        url: 'app/accounts/user/users.html',
        isPublic: false,
    },
    {
        pageName: 'myprofile',
        pageDisplayName: 'My Profile',
        isEnabled: true,
        url: 'app/accounts/user/myprofile.html',
        isPublic: true,
    },
    {
        pageName: 'pcc',
        pageDisplayName: 'My PACE Status',
        isEnabled: false,
        url: 'app/accounts/user/paceCredential/paceCredential.html',
        isPublic: false,
    },
    {
        pageName: 'financing',
        pageDisplayName: 'Financing',
        isEnabled: false,
        url: 'app/accounts/financing/financing.html',
        isPublic: false,
    },
    ];

    const userTableColumns = {
        firstName: {
            key: 'First',
            sort: true,
            val(row) {
                if (row === undefined || row === null) {
                    return '';
                }
                return row.FirstName;
            },
            apiColumnId: 1,
        },
        lastName: {
            key: 'Last',
            sort: true,
            val(row) {
                if (row === undefined || row === null) {
                    return '';
                }
                return row.LastName;
            },
            apiColumnId: 2,
        },
        offices: {
            key: 'Office(s)',
            sort: false,
            val(row) {
                if (row === undefined || row === null) {
                    return '';
                }
                let locations = '';
                _.each(row.LocationNames, (location) => {
                    if (location.Nickname !== undefined && location.Nickname !== null) {
                        locations = `${locations + location.Nickname}, `;
                    }
                });
                return locations.slice(0, locations.length - 2);
            },
        },
        role: {
            key: 'Role',
            sort: false,
            val(row) {
                if (row === undefined || row === null) {
                    return '';
                }
                return row.RoleName;
            },
        },
    };

    return {
        getAccountsPages,
        getCurrentAccountPage,
        getContractorUser,
        updateContractorUser,
        updateContactPreferences,
        validateContractorUserLicenseLicense,
        getContractorUserTrainings,
        getUsers,
        getUserTableColumns,
        getUserRoles,
        addOfficeToUser,
        addUser,
        reassignJobsAndRemoveOffice,
        reassignJobsAndDeleteUser,
        disableUser,
        enableUser,
        getContractorJobLocations,
        getContractorUsersByLocation,
        getContractorUserHISRequirementsStatus,
        getContractorUserHISTrainingRedirectURI,
        adjustContractorUserHISStatus,
        getCSLBLicenseHolders,
        setHISLicenseExemptionStatus,
        confirmContractorUserContactInfo,
        //		getEditProfileDirtyFlag: getEditProfileDirtyFlag,
        //		setEditProfileDirtyFlag: setEditProfileDirtyFlag
    };


    function getAccountsPages() {
        return _.filter(accountsPages, page => page.isEnabled === true);
    }

    function getCurrentAccountPage(pageName) {
        if (pageName === undefined || pageName === null) {
            return accountsPages[0];
        }
        const pages = _.filter(accountsPages, page => page.pageName === pageName);
        if (pages !== undefined && pages !== null && pages.length > 0) {
            return pages[0];
        }

        return accountsPages[0];
    }

    function getContractorUser(userId) {
        let url = `${HPConfig.heroProApi}ContractorUser/Profile`;
        if (userId !== undefined && userId !== null) {
            url += `?ContractorUserId=${userId.toString()}`;
        }
        return $http({
            url,
            method: 'GET',
        });
    }

    function updateContractorUser(params) {
        return $http({
            url: `${HPConfig.heroProApi}ContractorUser/Update`,
            method: 'POST',
            data: params,
        });
    }

    function confirmContractorUserContactInfo(params) {
        return $http({
            url: `${HPConfig.heroProApi}ContractorUser/ConfirmContactInfo`,
            method: 'POST',
            data: params,
        });
    }

    function updateContactPreferences(params) {
        return $http({
            url: `${HPConfig.heroProApi}ContractorUser/UpdateContactPreferences`,
            method: 'POST',
            data: params,
        });
    }

    function getContractorUsersByLocation(params) {
        return $http.get(`${HPConfig.heroProApi}Contractor/ContractorUsers`, {
            params,
        });
    }

    function getContractorJobLocations(params) {
        return $http.get(`${HPConfig.heroProApi}ContractorUser/JobLocations`, {
            params,
        });
    }

    function validateContractorUserLicenseLicense(params) {
        return $http.get(`${HPConfig.heroProApi}ContractorUser/Licenses/Validate`, {
            params,
        });
    }

    function getContractorUserTrainings() {
        return $http.get(`${HPConfig.heroProApi}ContractorUser/Trainings`);
    }

    function getContractorUserHISRequirementsStatus(params) {
        return $http.get(`${HPConfig.heroProApi}ContractorUser/GetHISRequirementsStatus`, {
            params,
        });
    }

    function getContractorUserHISTrainingRedirectURI(params) {
        return $http.get(`${HPConfig.heroProApi}ContractorUser/GetHISTrainingRedirectURI`, {
            params,
        });
    }

    function adjustContractorUserHISStatus(params) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/AdjustHISStatus`, params);
    }

    function getUsers(params) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/Management`, params);
    }

    function getUserTableColumns() {
        return userTableColumns;
    }

    function getUserRoles() {
        return $http({
            url: `${HPConfig.heroProApi}ContractorUser/Roles`,
            method: 'GET',
        });
    }

    function reassignJobsAndRemoveOffice(office, currentUser, newUser) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/RemoveFromLocation`, {
            ContractorLocationId: office.ContractorId,
            SalesRepContractorUserId: currentUser.ContractorUserId || null,
            NewSalesRepContractorUserId: newUser.ContractorUserId,
        });
    }

    function addOfficeToUser(params) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/AddLocation`, params);
    }

    function addUser(data) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/Add`, data);
    }

    function reassignJobsAndDeleteUser(params) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/Delete`, params);
    }

    function disableUser(params) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/Disable`, params);
    }

    function enableUser(params) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/Enable`, params);
    }

    function getCSLBLicenseHolders(params) {
        return $http.get(`${HPConfig.heroProApi}Organization/CSLBUsers`, {
            params,
        });
    }

    function setHISLicenseExemptionStatus(params) {
        return $http.post(`${HPConfig.heroProApi}ContractorUser/HISLicenseExemption`, params);
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/accountsFactory.js